module.exports = "/_next/static/images/img__card-5-touch-9f30981cc66ac6cfc907b97452d6e201.png";